import { render, staticRenderFns } from "./CustodialCareOrMaintenanceCare.vue?vue&type=template&id=7108ee95&scoped=true"
import script from "./CustodialCareOrMaintenanceCare.vue?vue&type=script&lang=js"
export * from "./CustodialCareOrMaintenanceCare.vue?vue&type=script&lang=js"
import style0 from "./CustodialCareOrMaintenanceCare.vue?vue&type=style&index=0&id=7108ee95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108ee95",
  null
  
)

export default component.exports